import iFrameResizer from 'iframe-resizer';

if ($('#ul_iframe').length) {
    iFrameResize({
        log: true
    }, '#ul_iframe')

};